import { GithubIcon } from "@/components/GithubIcon";
import { GitlabIcon } from "@/components/GitlabIcon";
import type { CodeHostKind } from "@/lib/api";

export function HostIcon({ host, className }: { host: CodeHostKind; className?: string }) {
  return host === "github" ? <GithubIcon className={className} /> : <GitlabIcon className={className} />;
}
